(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PersonIbqDetailController', PersonIbqDetailController);

    PersonIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Person', 'Country', 'Audio', 'Role', 'Specialty', 'Material', 'Photo'];

    function PersonIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Person, Country, Audio, Role, Specialty, Material, Photo) {
        var vm = this;

        vm.person = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:personUpdate', function(event, result) {
            vm.person = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
